<template>
  <b-row>
    <b-col cols="12" class="dropdowns dropdown-schlagworte" id="schlagworteDropdown">
      <template v-for="keyword in keywords">
        <!-- filter-buttons schlagworte / keywords  -->
        <button class="tag-schlagworte" :class="{selected_filter: filter.keywords.includes(keyword.title)}" :key="'key'+keyword.title" @click="filterKeyword(keyword)" >{{ keyword.title }}</button>
     </template>  
    </b-col>
    <b-col cols="12" class="dropdowns dropdown-rubriken" id="rubrikenDropdown">
       <template v-for="rubriken in categories">
         <!-- filter-buttons rubriken / categories  -->
        <button class="tag-rubriken" :class="{selected_filter: filter.categories.includes(rubriken)}" :key="'rub'+rubriken" @click="filterCategorie(rubriken)">{{ rubriken }}</button>
     </template>  
    </b-col>
    <b-col cols="12" class="dropdowns dropdown-autor" id="autorDropdown">
      <div class="autor-div">
          <div v-for="artikelAutor in authors" :key="'aut'+artikelAutor.id">
              <!-- filter-buttons autor_innen / authors  -->
             <button class="tag-author h3" :class="{selected_filter: filter.authors.includes(artikelAutor.title)}" @click="filterAuthor(artikelAutor)">{{ artikelAutor.title }}</button>
          </div>
      </div>
    </b-col>
    <b-col cols="12" class="dropdowns dropdown-ausgabe" id="ausgabeDropdown">
      <div class="ausgabe-div" >
          <div v-for="artikelAusgabeNr in issues" :key="'issue'+artikelAusgabeNr.id">
             <!-- filter-buttons ausgabe / issue  -->
            <button class="tag-ausgabe h3" :class="{selected_filter: filter.issues.includes(artikelAusgabeNr.title)}" @click="filterIssue(artikelAusgabeNr)">{{ artikelAusgabeNr.title }}</button>
          </div>
      </div>  
    </b-col>
  </b-row>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "filterRowDropdowns",
  components: {
    //Navigation
  },
  props: {
    DropdownOpen: Array
  },
  data() {
    return {
      entriesKeywords: [],
      entriesEntries: [],
/*      categories: [],
      keywords: [],
      issues: [],
      authors: [],*/
    };
  },
  created() {
    /*axios({
      url: "https://craft.femina-politica.de/api",
      method: "POST",
      data: {
        query: `
              query {
                categories(group: "schlagwortKategorien", orderBy: "title") {
                  id
                  title
                },
                entries(section: "archiv") {
                    ... on archiv_archiv_Entry {
                      artikelRubriken (label: true),
                      id
                      artikelAusgabeNr {
                        title,
                        url,
                        slug,
                        id
                      },
                      artikelAutor {
                        title,
                        url,
                        slug,
                        id
                      }
                    }
                }
              }
            `,
      },
    })
    .then((result) => {
      let dataKeywords = result.data.data.categories;
      let dataEntries = result.data.data.entries;
      console.log(dataKeywords);
      // assign the fetched data 2 times, once for manipulation
      // once for reseting
      /!*this.SET_CATEGORIES(dataKeywords);*!/
      /!*his.entriesKeywords = dataKeywords;
      this.entriesEntries = dataEntries;*!/
    });*/
  },
  mounted() {},
  computed:{
    ...mapGetters(['categories','keywords','issues','authors','filter']),
  },
  methods: {
    ...mapActions(['filterKeyword', 'filterCategorie', 'filterAuthor', 'filterIssue']),
    showHideSchlagworte() {
      document.getElementById("schlagworteDropdown").classList.toggle("show");
      if (document.getElementById("autorDropdown").classList.contains("show")){
        document.getElementById("autorDropdown").classList.remove("show")
      }
      if (document.getElementById("ausgabeDropdown").classList.contains("show")){
        document.getElementById("ausgabeDropdown").classList.remove("show")
      }
      if (document.getElementById("rubrikenDropdown").classList.contains("show")){
        document.getElementById("rubrikenDropdown").classList.remove("show")
      }
      document.getElementById("schlagworte").classList.toggle("border-active");
      if (document.getElementById("rubriken").classList.contains("border-active")){
        document.getElementById("rubriken").classList.remove("border-active")
      }
      if (document.getElementById("autoren").classList.contains("border-active")){
        document.getElementById("autoren").classList.remove("border-active")
      }
      if (document.getElementById("ausgabe").classList.contains("border-active")){
        document.getElementById("ausgabe").classList.remove("border-active")
      }
      document.getElementById("dropdown-icon-schlagworte").classList.toggle("flip-dropdown");
      if (document.getElementById("dropdown-icon-ausgabe").classList.contains("flip-dropdown")){
        document.getElementById("dropdown-icon-ausgabe").classList.remove("flip-dropdown")
      }
      if (document.getElementById("dropdown-icon-autoren").classList.contains("flip-dropdown")){
        document.getElementById("dropdown-icon-autoren").classList.remove("flip-dropdown")
      }
      if (document.getElementById("dropdown-icon-rubriken").classList.contains("flip-dropdown")){
        document.getElementById("dropdown-icon-rubriken").classList.remove("flip-dropdown")
      }
    }
  }
};
</script>

<style lang="scss">
@import "../assets/css/master.scss";
.selected_filter{
  color: red !important;
}
</style>